import script from "./PromoComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./PromoComponent.vue?vue&type=script&setup=true&lang=ts"

import "./PromoComponent.vue?vue&type=style&index=0&id=5fa28036&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5fa28036"]])

export default __exports__